import { Component, EventEmitter, Input, Output } from '@angular/core';


export type NoLocationBadgeType = 'items' | 'pictures';

@Component({
    selector: 'app-no-location-badge',
    imports: [],
    templateUrl: './no-location-badge.component.html',
    styleUrls: ['./no-location-badge.component.scss']
})
export class NoLocationBadgeComponent {
  @Input() count: number = 0;
  @Input() type: NoLocationBadgeType = 'items';
  @Input() thumbnailUrl: string | null = null;
  @Input() hasItemsBadge: boolean = false; // For positioning pictures badge when items badge exists
  @Input() isFullScreen: boolean = true; // Default to fullscreen (existing behavior)
  /** False: a count only (no pointer / hover), like the project map's ghost-location count off fullscreen. */
  @Input() clickable: boolean = true;

  @Output() badgeClick = new EventEmitter<MouseEvent>();

  get displayCount(): string {
    return this.count > 9 ? '9+' : this.count.toString();
  }

  onClick(event: MouseEvent): void {
    this.badgeClick.emit(event);
  }
}
